import React, {useEffect, useMemo, useState} from "react";
import clsx from "clsx";

function Product({id, info, isActiveProduct, onActiveChange }) {
    const lastUpdate = 'Last Price Update: ' + info.price_update;
    return (
        <div
            className={clsx("vzp_product plh_item d-flex flex-aligns-center me-3 me-lg-5 max-w-250px bg-white rounded", {'active': isActiveProduct})}
            data-id={id}
        >
            <a href="#" className="image-input image-input-outline" onClick={(e) => onActiveChange(e,id)}>
                <div className="image-input-wrapper w-100px h-100px" style={info.img ? {backgroundImage: 'url('+ info.img +')'} : {backgroundColor:info.color}} />
            </a>
            <div className="plh_info ms-1 p-2 min-w-150px fw-semibold">
                <a href={info.link} target="_blank" className="fs-6 text-hover-primary fw-bold text-truncate-2lines">
                    {info.name}
                    {info.brand != undefined ? ' (' + info.brand + ')' : ''}
                </a>
                {
                    info.price > 0.1 &&
                    <div className="text-gray-500">
                        <i className="ki-duotone ki-information-5 me-2">
                            <span className="path1"></span>
                            <span className="path2"></span>
                            <span className="path3"></span>
                        </i>
                        {
                            [info.price, info.currency]
                        }
                    </div>
                }
                <a href={info.link} target="_blank" data-bs-toggle="tooltip" data-bs-placement="top" title="View Product">
                    View
                    <i className="ki-duotone ki-exit-right-corner ms-1">
                        <span className="path1"></span>
                        <span className="path2"></span>
                    </i>
                </a>
            </div>
        </div>
    );
}

export default function ProductListHorizontal({products, activeProduct, fullModalState, onActiveChange, _onFullModalChange})  {
    // Manage Horizontal Block visibility
    const [ isHorizontalBlockOpen, setIsHorizontalBlockOpen ] = useState(true);
    const _toogleBlockOpen = () => {
        isHorizontalBlockOpen ? setIsHorizontalBlockOpen(false) : setIsHorizontalBlockOpen(true)
    };

    // Generate product list
    const productList = useMemo(() => {
        let temp = [];
        let count = 0;
        Object.keys(products.list).forEach(key => {
            temp.push(products.list[key]);
        });
        const productList = temp.map((node, i) =>
            (<Product
                key={i}
                id={node.id}
                info={node.info}
                isActiveProduct={activeProduct == node.id ? true : false}
                onActiveChange={onActiveChange}
            />)
        )
        return productList;
    }, [products.list, activeProduct]);


    return <>
        <div className="d-flex flex-row">
            <div className="d-flex flex-column justify-content-center align-items-center align-content-center h-120px">
                <button
                    className="d-flex flex-center bg-white rounded rounded-1 p-4 h-40px mx-3 mb-3 border-0"
                    onClick={(e) =>_onFullModalChange(e, 'products', fullModalState.products ? false : true)}
                >
                    <i className="ki-duotone ki-lots-shopping fs-2x">
                        <span className="path1"></span>
                        <span className="path2"></span>
                        <span className="path3"></span>
                        <span className="path4"></span>
                        <span className="path5"></span>
                        <span className="path6"></span>
                        <span className="path7"></span>
                        <span className="path8"></span>
                    </i>
                </button>
                <button className="d-flex flex-center bg-white rounded rounded-1 p-4 h-40px mx-3 border-0" onClick={_toogleBlockOpen}>
                    <i className={clsx("ki-duotone fs-2x", {'ki-exit-down': isHorizontalBlockOpen}, {'ki-exit-up': !isHorizontalBlockOpen})}>
                        <span className="path1"></span>
                        <span className="path2"></span>
                    </i>
                </button>
            </div>
            {
                isHorizontalBlockOpen &&
                <div className="overflow-auto d-flex align-items-center border border-dashed border-gray-300 border-x-0 w-100 p-3 rounded-1">
                    {productList}
                </div>
            }
        </div>
    </>
}